import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type {
  HandlersBulkNameSimsResponse,
  StructsNameSimsRequest,
} from 'types/__generated__/SimInventoryApi';
import type { HologramSimIdsMap } from 'types/common';

interface UseBulkSimRenameCallProps {
  hologramSimIds?: HologramSimIdsMap;
  organizationId?: OrgId;
}

// TODO: Need to add the preview version too
const useBulkSimRenameCall = ({ hologramSimIds, organizationId }: UseBulkSimRenameCallProps) => {
  const url = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/name`;

  const callback = useCallback(
    async (name: string, applySuffix?: boolean) => {
      if (!url || !hologramSimIds || hologramSimIds.size === 0) {
        return undefined;
      }

      const body: StructsNameSimsRequest = {
        hologramSimIds: [...hologramSimIds!.keys()],
        name,
        organizationId,
      };

      if (applySuffix !== undefined) {
        body.applySuffix = applySuffix;
      }

      const result: HandlersBulkNameSimsResponse = await postFetcher({
        url,
        body,
      });

      return result;
    },
    [hologramSimIds, organizationId, url]
  );

  return callback;
};

export default useBulkSimRenameCall;
